module.exports = "/assets/data/9e371bc6dc570cd0354e0b44d9564145-B72.data.json";